// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__XwRDx","left":"InfoRow_left__2wBY0"};